const addingCustomStyles = {
    name: "Adding custom styles",
    path: "adding-custom-styles",
    title: "Adding Custom Styles",
    description: "Best practices for adding your own custom styles in Unicss projects.",
    heading: false,
    exampleData: [
        {
            "title": "",
            "description": "Unicss has been designed from the ground up to be extensible and customizable, so that no matter what you’re building you never feel like you’re fighting the framework.",
            "moreDescription": "This guide covers topics like customizing your design tokens, how to break out of those constraints when necessary, adding your own custom CSS, and extending the framework",
            "parentClass": "!bg-none !border-0",
            "example": {
                "element": "div",
                "className": "relative",
            }
        },
        {
            "title": "Customizing your theme",
            "description": "",
            "moreDescription": "If you want to change things like your color palette, spacing scale, root class, or breakpoints, add your customizations using the unicss.config.js file in your project root:",
            "parentClass": "!bg-none !border-0",
            "example": {
                "element": "div",
                "className": "relative",
                "code": `<!-- unicss.config.js -->
module.exports = {
  theme: {
    extend: {
      breakpoints: {
        "3xl": "120rem",
      },
      colors: {
        "color-accent": "#22c55e",
        "color-primary": "#2563eb",
      },
        : {
        "text-10xl": "9rem",

      },
      spacing: {
        "19": "4.75rem",
      },
    },
  },
};


<!-- Or Using Custom CSS File -->
:root {
  --color-accent: #22c55e;
  --color-primary: #2563eb;
  --19: 4.75rem;
  --text-10xl: 9rem;
}

`
            },

        }
    ]
};

export default addingCustomStyles;
